import GalleryDetail from "./GalleryDetail";

export default GalleryDetail